import { FormikSpinButton } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { Position } from 'office-ui-fabric-react/lib/utilities/positioning'
import * as React from 'react'

export class ProvingDetailsUsageTimeFormValues {}

export const ProvingDetailsUsageTimeForm: React.FunctionComponent = () => {
  // const { t } = useTranslation()

  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name={'usageTime'}
          render={(fieldProps) => (
            <FormikSpinButton
              label={'Anzahl'}
              labelPosition={Position.top}
              min={0}
              max={24}
              step={1}
              {...fieldProps}
            />
          )}
        />
      </FieldStack>
    </FormStack>
  )
}
